export default "skymp5-front/2be485c80b7e0bb264d997245bf8e79c.png";